import React from 'react';
import { cn } from '../../utils/cn';

const SPACING = {
  0: 'gap-0', 1: 'gap-1', 2: 'gap-2', 3: 'gap-3', 4: 'gap-4', 5: 'gap-5', 6: 'gap-6', 8: 'gap-8', 10: 'gap-10', 12: 'gap-12',
};

const ALIGN = {
  start:   'items-start',
  center:  'items-center',
  end:     'items-end',
  stretch: 'items-stretch',
  baseline:'items-baseline',
};

const JUSTIFY = {
  start:   'justify-start',
  center:  'justify-center',
  end:     'justify-end',
  between: 'justify-between',
  around:  'justify-around',
  evenly:  'justify-evenly',
};

export function VStack({ gap = 3, align = 'stretch', justify, wrap, as: Tag = 'div', className, children, ...rest }) {
  return (
    <Tag className={cn('flex flex-col', SPACING[gap], ALIGN[align], justify && JUSTIFY[justify], wrap && 'flex-wrap', className)} {...rest}>
      {children}
    </Tag>
  );
}

export function HStack({ gap = 3, align = 'center', justify, wrap, as: Tag = 'div', className, children, ...rest }) {
  return (
    <Tag className={cn('flex flex-row', SPACING[gap], ALIGN[align], justify && JUSTIFY[justify], wrap && 'flex-wrap', className)} {...rest}>
      {children}
    </Tag>
  );
}

export const Stack = VStack;
export default Stack;
